//1.导入Vue和VueRouter的包
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/index/index.vue'
import Introduce from '@/views/introduce/index.vue'
import Ecological from '@/views/ecological/index.vue'
import News from '@/views/news/index.vue'
import KeFu from '@/views/kefu/index.vue'
import NewsDetail from '@/views/newsDetail/index.vue'
import Business from '@/views/business/index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Home
  },
  {
    path: '/index',
    name: 'Home',
    component: Home
  }, {
    path: '/introduce',
    name: 'Introduce',
    component: Introduce
  }, {
    path: '/ecological',
    name: 'Ecological',
    component: Ecological
  }, {
    path: '/news',
    name: 'News',
    component: News
  }, {
    path: '/newsDetail',
    name: 'NewsDetail',
    component: NewsDetail
  }, {
    path: '/kefu',
    name: 'KeFu',
    component: KeFu
  }, {
    path: '/business',
    name: 'Business',
    component: Business
  }
]
//3.创建路由的实例对象
const router = new VueRouter({
  mode: 'history',
  routes
})
//4.向外共享路由的实例对象
export default router